<template>

  <router-view/>
</template>
<script>
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  methods:{


}
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.modal__error {
  width: 30vw;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 1.3vw;
  padding: 1.1vw;
  box-shadow: 0 0 3px 2px #eee;
  background-color: #eceded;
  border: 0.1vw solid;

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;

    & > p {

      font-size: 1.1vw;

      &:nth-child(2) {
        cursor: pointer;
      }

    }
  }

  & > div:last-child {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    & > p {
      font-size: 1.1vw;


    }

    & > button {
      font-size: 1vw;
      width: 8vw;
      background-color: #3742FA;
      color: #fff;
      border: unset;
      border-radius: .5vw;
      height: 2vw;
      margin-top: 2.5vw;
      margin-bottom: 2.5vw;
      cursor: pointer;


    }
  }
}
</style>
